/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_No_PeopleInputs */

const cs_settings_venues_no_people = /** @type {(inputs: Settings_Venues_No_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`K této pobočce zatím nikdo nepatří.`)
};

const en_settings_venues_no_people = /** @type {(inputs: Settings_Venues_No_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No one is assigned to this venue yet.`)
};

/**
* | output |
* | --- |
* | "No one is assigned to this venue yet." |
*
* @param {Settings_Venues_No_PeopleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_no_people = /** @type {((inputs?: Settings_Venues_No_PeopleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_No_PeopleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_no_people(inputs)
	return cs_settings_venues_no_people(inputs)
});